exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".EventMessages{font-family:Lato,sans-serif;font-weight:400}.EventMessages p{margin:0;font-size:.8rem;line-height:1.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/Components/Timeline/EventMessages.scss
// module id = 230
// module chunks = 0